import { Category } from "@utilities/types/category.type";
import React, { createContext, useState, PropsWithChildren } from "react";

interface CategoryContextType {
    categories: Category[];
    setCategories: React.Dispatch<React.SetStateAction<Category[]>>;
}

export const CategoryContext = createContext<CategoryContextType>({
    categories: [],
    setCategories: () => { },
});

export const CategoryContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [categories, setCategories] = useState<Category[]>([]);

    return (
        <CategoryContext.Provider value={{ categories, setCategories }}>
            {children}
        </CategoryContext.Provider>
    );
};
